window.ErrorHandler = (function () {
	var selectors = {
		errorContainer: '#app__error'
	}

	function show() {
		$(selectors.errorContainer).addClass('m-visible');
	}

	function hide() {
		$(selectors.errorContainer).removeClass('m-visible');
	}

	function handle(jqXHR, textStatus, errorThrown) {
	    show();
	    setTimeout(function () {
	        Ajax.redirect(window.location.pathname);
	    }, 2000);


/*
		console.log('textStatus: ', textStatus);
		console.log('errorThrown: ', errorThrown);
		console.log('XHR: ', jqXHR);
		console.log('XHR.responseJSON: ', jqXHR.responseJSON);
		console.log('XHR.responseTEXT(first 20): ', jqXHR.responseText);
*/
	}

	return {
		show: show,
		hide: hide,
		handle: handle
	}
}());

